<template>
  <div v-for="option in options" :key="option" class="text-left w-full">
    <div class="text-center flex items-center mb-2">
      <span
        class="font-semibold bg-bnb-mustard2 px-4 text-bnb-brown rounded-r-md bg-opacity-70"
        >{{ option.title }}</span
      >
      <img
        v-show="choice == 'Scrambled'"
        class="h-8 ml-2"
        src="@/assets/eggs/scrambled.png"
      />
      <img
        v-show="choice == 'Poached'"
        class="h-8 ml-2"
        src="@/assets/eggs/poached.png"
      />
      <img
        v-show="choice == 'Sunny side up'"
        class="h-8 ml-2"
        src="@/assets/eggs/sunnysideup.png"
      />
      <img
        v-show="choice == 'Boiled'"
        class="h-8 ml-2"
        src="@/assets/eggs/boiled.png"
      />
      <img
        v-show="choice == 'Plain Omelette'"
        class="h-8 ml-2"
        src="@/assets/eggs/plainomelette.png"
      />
      <img
        v-show="choice == 'Spanish Omelette'"
        class="h-8 ml-2"
        src="@/assets/eggs/spanishomelette.png"
      />
    </div>
    <div class="gap-y-2 gap-x-2 grid grid-cols-3 text-sm">
      <div
        v-for="choice in option.choices"
        :key="choice"
        class="flex items-center space-x-2"
      >
        <input
          @click="customize(choice.id, choice.title)"
          class="radio"
          type="radio"
          :id="choice.title"
          :name="options"
          :value="choice.id"
        />
        <label
          :class="{ 'font-bold text-bnb-mustard': customizedID == choice.id }"
          :for="choice.title"
          >{{ choice.title }}</label
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: { options: Object },
  data() {
    return {
      customizedID: "",
      choice: "",
    };
  },
  computed: {
    choiceImage() {
      return "";
    },
  },
  methods: {
    customize(id, choice) {
      this.customizedID = id;
      this.choice = choice;
      this.$emit("customized", id);
    },
  },
};
</script>

<style scoped>
input[type="radio"]:after {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  top: -2px;
  left: -1px;
  position: relative;
  background-color: #d1d3d1;
  content: "";
  display: inline-block;
  visibility: visible;
  border: 2px solid white;
}

input[type="radio"]:checked:after {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  top: -2px;
  left: -1px;
  position: relative;
  background-color: #f2a90d;
  content: "";
  display: inline-block;
  visibility: visible;
  border: 2px solid white;
}
</style>
